import Vue from 'vue';
import Router from 'vue-router';
import Login from '../screens/Login';
import CadastrarUsuario from '../screens/CadastroUsuario';
import SelecionarModulo from '../screens/SelecionarModulo';
import SelecionarPerfil from '../screens/SelecionarPerfil';
import CadastrarSenha from '../screens/CadastrarSenha';

import store from '../store';

Vue.use(Router);

const beforeEnterLogout = (to, from, next) => {
  store.dispatch('auth/logout').then(() => {
    next('/login');
  });
};

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: '/selecionarModulo',
      name: 'selecionarModulo',
      component: SelecionarModulo,
      meta: { requiresAuth: true },
    },
    {
      path: '/selecionarPerfil',
      name: 'selecionarPerfil',
      component: SelecionarPerfil,
      meta: { requiresAuth: true },
    },
    {
      path: '/cadastrar',
      name: 'cadastroUsuario',
      component: CadastrarUsuario,
      meta: { requiresAuth: false },
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { requiresAuth: false },
      beforeEnter: beforeEnterLogout,
    },
    {
      path: '/cadastrarSenha/:codigo',
      name: 'cadastrarSenha',
      component: CadastrarSenha,
      meta: { isPublic: true },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const usuario = await store.dispatch('auth/getUsuario');

    if (!usuario) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
